import { render, staticRenderFns } from "./ScreenReader.vue?vue&type=template&id=88c3d48e&scoped=true"
import script from "./ScreenReader.vue?vue&type=script&lang=js"
export * from "./ScreenReader.vue?vue&type=script&lang=js"
import style0 from "./ScreenReader.vue?vue&type=style&index=0&id=88c3d48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c3d48e",
  null
  
)

export default component.exports